import axios from 'axios';

const API_BASE_URL = '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// 添加请求拦截器，自动添加Authorization头
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    const currentTenant = localStorage.getItem('currentTenant') || 'default';
    config.headers['X-Tenant-Code'] = currentTenant;
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export interface MCPService {
  id: number;
  tenant_code: string;
  name: string;
  database_name: string;
  address: string;
  headers: string;
  status: string;
  is_active: number;
  created_by?: string;
  created_at?: string;
  updated_at?: string;
}

export interface CreateMCPServiceRequest {
  name: string;
  database_name?: string;
  address: string;
  headers: string;
  created_by?: string;
}

export interface UpdateMCPServiceRequest {
  name?: string;
  database_name?: string;
  address?: string;
  headers?: string;
  status?: string;
  is_active?: number;
}

class MCPServiceAPI {
  private tenant: string = 'default';

  setTenant(tenant: string) {
    this.tenant = tenant;
  }

  // 获取所有MCP服务
  async getMCPServices(): Promise<MCPService[]> {
    const response = await api.get(`/${this.tenant}/mcp-services`);
    return response.data.data || [];
  }

  // 获取单个MCP服务
  async getMCPService(id: number): Promise<MCPService> {
    const response = await api.get(`/${this.tenant}/mcp-services/${id}`);
    return response.data.data;
  }

  // 创建MCP服务
  async createMCPService(service: CreateMCPServiceRequest): Promise<MCPService> {
    const response = await api.post(`/${this.tenant}/mcp-services`, service);
    return response.data.data;
  }

  // 更新MCP服务
  async updateMCPService(id: number, service: UpdateMCPServiceRequest): Promise<MCPService> {
    const response = await api.put(`/${this.tenant}/mcp-services/${id}`, service);
    return response.data.data;
  }

  // 删除MCP服务
  async deleteMCPService(id: number): Promise<void> {
    await api.delete(`/${this.tenant}/mcp-services/${id}`);
  }

  // 测试MCP服务连接
  async testConnection(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/${this.tenant}/mcp-services/${id}/test`);
    return response.data;
  }

  // 切换MCP服务状态
  async toggleStatus(id: number, is_active: boolean): Promise<MCPService> {
    const response = await api.patch(`/${this.tenant}/mcp-services/${id}/status`, {
      is_active
    });
    return response.data.data;
  }
}

export const mcpService = new MCPServiceAPI();
